var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('common-sur-header'),_c('common-header',{attrs:{"nav-items":_vm.header.navItems,"cta-buttons":_vm.header.ctaButtons}}),_c('div',{staticClass:"landing-main-section"},[_c('iframe',{staticClass:"iframe-reservation",attrs:{"src":'https://admin.popvalet.com/reservation/' + _vm.idReservation}})]),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }